/**
 * The main application initializer.
 * It scans the DOM for data-component attributes and dynamically loads
 * the corresponding component module.
 */

// Map component names (from data-component attributes) to their modules.
const components = {
    'back-to-top': () => import('./components/BackToTop.js'),
    'smooth-scroll': () => import('./components/SmoothScroll.js'),
    'match-height': () => import('./components/Match.js'),
    'modal': () => import('./components/FPmodal.js'),
    'accordion': () => import('./components/Accordion.js')
    // ... add all your components here
};

// The main initialization function
function init() {
    const elements = document.querySelectorAll('[data-component]');

    elements.forEach((element) => {
        const componentName = element.dataset.component;

        if (components[componentName]) {
            components[componentName]()
                .then(module => {
                    const Component = module.default;
                    if (typeof Component === 'function') {
                        new Component(element);
                    }
                })
                .catch(error => {
                    console.error(`Failed to load component: ${componentName}`, error);
                });
        }
    });
}

// Export an object with the init method.
export default {
    init
};